// extracted by mini-css-extract-plugin
export default {"logoBlockWrapper":"styles_logoBlockWrapper__nPqby","contentWrapper":"styles_contentWrapper__5Kg-p"};